<!--  -->
<template>
  <div class='wrapper  box_v'>
    <!--头部-->
    <page-head title="新增人员" :btn-list="btnList" :show-back="true" @handleBtn="handleBtn">
    </page-head>
    <div class="box_f1 box_v card-box" >
      <Card dis-hover :padding="20" style="position: relative">
        <Spin fix v-if="spinShow"></Spin>
        <i-form ref="form1" label-position="top">
          <row :gutter="80">
            <i-col span="8" v-if="setting.headPicUrl">
              <FormItem label="照片" prop="headPicUrl">
                <upl-img-act
                  :imgArr="imgArr"
                  :imgNumber="imgNumber"
                  :fixedNumber="fixedNumber"
                  :imgHeight="100"
                  :imgWidth="100"
                  @saveImg="saveImg"
                  @delPic="delImg"
                  class="upload"
                >
                  <div class="uploadbox">
                    <i class="iconfont icon-shangchuan1"></i>
                    <p>上传图片</p>
                  </div>
                </upl-img-act>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="setting.name">
              <FormItem label="姓名" prop="name">
                <Input v-model="people.name" placeholder="请输入真实姓名"/>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="setting.sex">
              <FormItem label="性别" prop="sex">
                <Select v-model="people.sex">
                  <Option v-for="item in sex" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="setting.cardno">
              <FormItem label="身份证号" prop="cardno">
                <Input v-model="people.cardno" placeholder="请输入身份证号"/>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="setting.birthday">
              <FormItem label="出生日期" prop="birthday">
                <DatePicker v-model="people.birthday" type="date" placeholder="请选择出生日期"></DatePicker>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="setting.nationalId">
              <FormItem label="民族" prop="nationalId">
                <Select v-model="people.nationalId">
                  <Option v-for="item in national" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="setting.phone">
              <FormItem label="联系电话" prop="phone">
                <Input v-model="people.phone" placeholder="请输入联系电话"/>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="setting.phone2">
              <FormItem label="联系电话2" prop="phone2">
                <Input v-model="people.phone2" placeholder="请输入联系电话2"/>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="setting.workPlace">
              <FormItem label="工作单位" prop="workPlace">
                <Input v-model="people.workPlace" placeholder="请输入工作单位"/>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="setting.needGo2Work">
                <FormItem label="是否需要上班" prop="needGo2Work">
                  <RadioGroup v-model="people.needGo2Work">
                    <Radio :label="1">是</Radio>
                    <Radio :label="0">否</Radio>
                  </RadioGroup>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="(setting.needGo2Work && people.needGo2Work==1) || (!setting.needGo2Work && setting.workPromisePicUrl)">
                <FormItem label="证明" prop="workPromisePicUrl">
                  <upl-img-act
                    :imgArr="imgArrWork"
                    :imgNumber="imgNumber"
                    :fixedNumber="fixedNumber"
                    :imgHeight="100"
                    :imgWidth="100"
                    @saveImg="saveImgWork"
                    @delPic="delImgWork"
                    class="upload"
                  >
                    <div class="uploadbox">
                      <i class="iconfont icon-shangchuan1"></i>
                      <p>上传图片</p>
                    </div>
                  </upl-img-act>
                </FormItem>
            </i-col>
          </row>
          <row :gutter="80">
            <i-col span="8">
               <i-col span="8" v-if="setting.idCardNOUpPicUrl">
              <FormItem label="身份证正面" prop="idCardNOUpPicUrl">
                <upl-img-act
                  :imgArr="imgIdCardFArr"
                  :imgNumber="imgNumber"
                  :fixedNumber="fixedNumber"
                  :imgHeight="100"
                  :imgWidth="100"
                  @saveImg="saveIdCardFImg"
                  @delPic="delIdCardFImg"
                  class="upload"
                >
                  <div class="uploadbox">
                    <i class="iconfont icon-shangchuan1"></i>
                    <p>上传图片</p>
                  </div>
                </upl-img-act>
              </FormItem>
            </i-col>
            </i-col>

             <i-col span="8">
               <i-col span="8" v-if="setting.idCardNODownPicUrl">
              <FormItem label="身份证反面" prop="idCardNODownPicUrl">
                <upl-img-act
                  :imgArr="imgIdCardBArr"
                  :imgNumber="imgNumber"
                  :fixedNumber="fixedNumber"
                  :imgHeight="100"
                  :imgWidth="100"
                  @saveImg="saveIdCardBImg"
                  @delPic="delIdCardBImg"
                  class="upload"
                >
                  <div class="uploadbox">
                    <i class="iconfont icon-shangchuan1"></i>
                    <p>上传图片</p>
                  </div>
                </upl-img-act>
              </FormItem>
            </i-col>
            </i-col>

             <i-col span="8">
               <i-col span="8" v-if="setting.employeeHealthyPicUrl">
              <FormItem label="健康证明" prop="employeeHealthyPicUrl">
                <upl-img-act
                  :imgArr="imgEHealthArr"
                  :imgNumber="imgNumber"
                  :fixedNumber="fixedNumber"
                  :imgHeight="100"
                  :imgWidth="100"
                  @saveImg="saveEHealthImg"
                  @delPic="delEHealthImg"
                  class="upload"
                >
                  <div class="uploadbox">
                    <i class="iconfont icon-shangchuan1"></i>
                    <p>上传图片</p>
                  </div>
                </upl-img-act>
              </FormItem>
            </i-col>
            </i-col>
          </row>
          <row :gutter="80">
            <i-col span="8" v-if="setting.returnWorkTime">
              <FormItem :label="'该员工复工复业时间'" prop="returnWorkTime">
                <DatePicker v-model="people.returnWorkTime" format="yyyy-MM-dd" placeholder="请选择"></DatePicker>
              </FormItem>
            </i-col>
                <i-col span="8" v-if="setting.place4BeforeReturnWork">
              <FormItem :label="'复工复业前居住地'" prop="place4BeforeReturnWork">
                <Input v-model="people.place4BeforeReturnWork"/>
              </FormItem>
            </i-col>
          </row>
         
          <row :gutter="80">
            <i-col span="8" v-if="setting.community_id">
              <FormItem label="行政区域" prop="communityId">
                <Select v-model="people.communityId" class="input" @on-change="changeCommuintyId">
                  <Option v-for="item in childShequ" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
              </FormItem>
            </i-col>

            <i-col span="8"  v-if="$store.state.apptype!='ctt'">
              <FormItem label="所属小区" prop="zoneId">
                <Select v-model="people.zoneId" class="input" @on-open-change="selectZone">
                  <Option v-for="item in zoneList" :value="item.id" :key="item.id">{{ item.zoneName }}</Option>
                </Select>
              </FormItem>
            </i-col>

            <i-col span="8" v-if="setting.domicilePalce">
              <FormItem label="户籍地" prop="domicilePalce">
                
                <Select v-model="people.domicileCountry" style="margin-bottom: 10px">
                  <Option v-for="item in domicileCountry" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
            
                <Cascader v-if="people.domicileCountry == 'CHN'" v-model="people.domicilePalce" :data="areadata" :load-data="getArea" placeholder="请选择户籍地址"></Cascader>
                <Input v-if="people.domicileCountry == 'FOR'" v-model="people.domicilePalce" placeholder="请输入户籍地址"/>
                 
              </FormItem>
            </i-col>
            <i-col span="8" v-if="setting.address">
              <FormItem label="现居住地址" prop="address">
                <Input v-model="people.address" placeholder="请输入小区名称"/>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="setting.buildingNO">
              <FormItem label="楼栋号" prop="buildingNO">
                <Input v-model="people.buildingNO" placeholder="请输入楼栋号"/>
              </FormItem>
            </i-col>
             <i-col span="8" v-if="setting.unitNO">
              <FormItem label="单元号" prop="unitNO">
                <Input v-model="people.unitNO" placeholder="请输入单元号"/>
              </FormItem>
            </i-col>
             <i-col span="8" v-if="setting.roomNO">
              <FormItem label="房间号" prop="roomNO">
                <Input v-model="people.roomNO" placeholder="请输入房间号"/>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="setting.liveType">
              <FormItem label="居住类型" prop="liveType">
                <Select v-model="people.liveType">
                  <Option v-for="item in liveType" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="setting.familyNum">
              <FormItem label="家庭成员" prop="familyNum">
                <InputNumber :min="0" v-model="people.familyNum" placeholder="请输入家庭成员数量"></InputNumber>
                <!-- <Input  type="number" v-model="people.familyNum" placeholder="请输入家庭成员数量"/> -->
              </FormItem>
            </i-col>
            <i-col span="8" v-if="setting.familyMember">
              <FormItem label="家庭成员姓名" prop="familyMember">
                <Input v-model="people.familyMember" placeholder="请输入家庭成员姓名,以逗号分隔"/>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="setting.contact">
              <FormItem label="过去两周内接触情况" prop="contact">
                <Select v-model="people.contact" multiple>
                  <Option v-for="item in contact" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="setting.symptomSelf">
              <FormItem label="自身或家人症状" prop="symptomSelf">
                <Select v-model="people.symptomSelf" multiple>
                  <Option v-for="item in symptom" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="setting.symptomFamily">
              <FormItem label="家人症状" prop="symptomFamily">
                <Select v-model="people.symptomFamily" multiple>
                  <Option v-for="item in symptom" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </i-col>
          </row>

          <row :gutter="80">
            <i-col span="8" v-if="setting.fever">
              <FormItem label="是否发热" prop="fever">
                <RadioGroup v-model="people.fever">
                  <Radio label="1">是</Radio>
                  <Radio label="2">否</Radio>
                </RadioGroup>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="setting.handleType && people.fever==1">
              <FormItem label="发热人员处置方式" prop="handleType">
                <Select v-model="people.handleType">
                  <Option v-for="item in handleType" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="setting.leaveHere">
              <FormItem :label="isWuhan?'是否为近期返城人员':('近一月是否离'+cityremark)" prop="leaveHere">
                <RadioGroup v-model="people.leaveHere">
                  <Radio label="1">是</Radio>
                  <Radio label="2">否</Radio>
                </RadioGroup>
              </FormItem>
            </i-col>
          </row>

          <row :gutter="80">
            <i-col span="8" v-if="setting.isAddToday">
              <FormItem :label="'是否为当日新增从业人员'" prop="isAddToday">
                <RadioGroup v-model="people.isAddToday">
                  <Radio label="1">是</Radio>
                  <Radio label="0">否</Radio>
                </RadioGroup>
              </FormItem>
            </i-col>
              <i-col span="8" v-if="setting.remark">
              <FormItem label="备注" prop="remark">
                <Input v-model="people.remark" type="textarea" placeholder="请输入"/>
              </FormItem>
            </i-col>
             <i-col span="8" v-if="setting.returnTime">
              <FormItem :label="'何日离'+cityremark" prop="returnTime">
                <DatePicker v-model="people.returnTime" format="yyyy-MM-dd" placeholder="请选择"></DatePicker>
              </FormItem>
            </i-col>
              <i-col span="8" v-if="setting.classAndGrade">
              <FormItem label="年级" prop="grade">
                 <Select v-model="people.grade" clearable>
                      <Option v-for="item in gradeList" :value="item.label" :key="item.value">{{ item.label }}</Option>
                    </Select>
              </FormItem>
            </i-col>
             <i-col span="8" v-if="setting.classAndGrade">
              <FormItem label="班级" prop="class">
                  <Select v-model="people.class" clearable>
                      <Option v-for="item in classList" :value="item.label" :key="item.value">{{ item.label }}</Option>
                    </Select>
              </FormItem>
            </i-col>
             <i-col span="8" v-if="setting.beenRiskAreaName">
                <FormItem :label="'去过重点地区/中高风险地区'" prop="beenRiskAreaName">
                   <Input v-model="people.beenRiskAreaName" disabled placeholder=""/>
                </FormItem>
              </i-col>
          </row>
        </i-form>

        <i-form ref="form2" label-position="top" v-if="people.leaveHere=='1'">
          <row :gutter="80">
            <i-col span="8" v-if="setting.promisePicUrl">
              <FormItem label="承诺书" prop="promisePicUrl">
                <upl-img-act
                  :imgArr="imgArrPromise"
                  :imgNumber="imgNumber"
                  :fixedNumber="fixedNumber"
                  :imgHeight="100"
                  :imgWidth="100"
                  @saveImg="savePromiseImg"
                  @delPic="delPromiseImg"
                  class="upload"
                >
                  <div class="uploadbox">
                    <i class="iconfont icon-shangchuan1"></i>
                    <p>上传图片</p>
                  </div>
                </upl-img-act>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="setting.healthyPicUrl">
              <FormItem label="健康证明" prop="healthyPicUrl">
                <upl-img-act
                  :imgArr="imgArrHealthy"
                  :imgNumber="imgNumber"
                  :fixedNumber="fixedNumber"
                  :imgHeight="100"
                  :imgWidth="100"
                  @saveImg="saveHealthyImg"
                  @delPic="delHealthyImg"
                  class="upload"
                >
                  <div class="uploadbox">
                    <i class="iconfont icon-shangchuan1"></i>
                    <p>上传图片</p>
                  </div>
                </upl-img-act>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="setting.leaveWay">
              <FormItem label="离开方式" prop="leaveWay">
                <Select v-model="people.leaveWay">
                  <Option v-for="item in returnWay" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="setting.leaveTrips">
            <FormItem label="离开车次/航班号" prop="leaveTrips">
              <Input v-model="people.leaveTrips" placeholder="请输入车次/航班号,以逗号分隔"/>
            </FormItem>
          </i-col>
            <i-col span="8" v-if="setting.stayWuHan">
              <FormItem label="是否途经/中转/停留中高风险地区" prop="stayWuHan">
                <Select v-model="people.stayWuHan">
                  <Option v-for="item in stay" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="setting.returnWay">
              <FormItem label="返回方式" prop="returnWay">
                <Select v-model="people.returnWay">
                  <Option v-for="item in returnWay" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="setting.returnTrips">
              <FormItem label="返回车次/航班号" prop="returnTrips">
                <Input v-model="people.returnTrips" placeholder="请输入车次/航班号,以逗号分隔"/>
              </FormItem>
            </i-col>
           
            <i-col span="8" v-if="setting.fromWhere">
              <FormItem :label="'从何地回'+cityremark" prop="fromWhere">
                <Select v-model="people.fromCountry" style="margin-bottom: 10px">
                  <Option v-for="item in domicileCountry" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
                <Cascader v-if="people.fromCountry == 'CHN'" v-model="people.fromWhere" :data="areadata" :load-data="getArea" placeholder="请选择"></Cascader>
                <Input v-if="people.fromCountry == 'FOR'" v-model="people.fromWhere" placeholder="请输入地址"/>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="setting.backTime">
              <FormItem :label="'回'+cityremark+'日期'" prop="backTime">
                <DatePicker v-model="people.backTime" format="yyyy-MM-dd" placeholder="请选择"></DatePicker>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="setting.relation">
              <FormItem :label="'回'+cityremark+'接触人员'" prop="relation">
                <Input type="textarea" v-model="people.relation" placeholder="请输入接触人员"/>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="setting.footprint">
              <FormItem label="所到过的区域" prop="footprint">
                <Input type="textarea" v-model="people.footprint" placeholder="请输入所到过的区域"/>
              </FormItem>
            </i-col>
          </row>
        </i-form>
      </Card>
    </div>
  </div>
</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';
  import pageHead from '../../../components/head'
  import uploadImg from "../../../components/uploadImg";
  import uplImgAct from "../../../components/uplImgAct";
  
  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {pageHead,uploadImg,uplImgAct},
    data() {
      //这里存放数据
      return {
        spinShow:false,
        communityId:'',
        cityremark: sessionStorage.cityremark,
        isWuhan:sessionStorage.isWuhan && JSON.parse(sessionStorage.isWuhan),
        btnList: [{
          name: '提交',
          type: 'submit',
          loading: false,
        }],
        zoneList:[],
        setting:{}, 
        gradeList:[],
        classList:[],
        //人员信息
        people: {
          id: -1,
          name: '',
          sex:'',
          cardno: '',
          birthday:'',
          phone: '',
          phone2:'',
          nationalId:'',
          workPlace:'',
          domicilePalce: [], //户籍地
          address: '',
          liveType:'',
          familyNum: 0,
          familyMember: '',
          contact:[],
          symptomSelf:[],
          symptomFamily:[],
          stayWuHan:0,
          returnWay:'',
          fever: "2",
          leaveHere: '2',
          returnTime: '',
          fromWhere: [],//从何地回京
          backTime: '',//回京日期
          relation: '',
          footprint: '',
          remark: '',
          headPicUrl:'',
          promisePicUrl:'',
          healthyPicUrl:'',
          fromCountry:'CHN',
          domicileCountry:'CHN',
          needGo2Work:0,
          returnWorkTime: '',
          idCardNOUpPicUrl: '',
          idCardNODownPicUrl: '',
          employeeHealthyPicUrl: '',
          isAddToday: '1',
          handleType: "",
          place4BeforeReturnWork: '',
          grade: "",
          class: "",
        },
        imgArr:[],
        imgIdCardFArr:[],
        imgIdCardBArr:[],
        imgEHealthArr:[],
        imgArrWork:[],
        imgArrPromise:[],
        imgArrHealthy:[],
        imgNumber: 1,
        fixedNumber: [1, 1],
        //行政区域
        areadata: [],
        //人员搜索信息
        peopleData: [],
        sex: [{label: '男', value: 1}, {label: '女', value: 0}],
        national: [],
        symptom: [{
          label: '咳嗽',
          value: 1
        },
        //  {
        //   label: '感冒',
        //   value: 2
        // },
        {
          label: '发烧',
          value: 4
        },
        // {
        //   label: '乏力',
        //   value: 8
        // }, {
        //   label: '呼吸困难',
        //   value: 16
        // }, {
        //   label: '腹泻',
        //   value: 32
        // },
        {
          label: '其他',
          value: 64
        }, {
          label: '正常',
          value: 0
        }],
        returnWay: [{
          label: '飞机',
          value: 1
        }, {
          label: '火车',
          value: 2
        }, {
          label: '大巴',
          value: 4
        }, {
          label: '轮船',
          value: 8
        }, {
          label: '拼车',
          value: 16
        }, {
          label: '自驾',
          value: 32
        }],
        stay: [{
          label: '是',
          value: 1
        }, {
          label: '否',
          value: 0
        }],
        liveType: [{
          label: '自有房屋',
          value: 1
        }, {
          label: '租赁房屋',
          value: 2
        }, {
          label: '借住房屋',
          value: 4
        }, {
          label: '其它',
          value: 8
        }],
        contact: [{
          label: '接触过境外返回人员',
          value: 1
        },
        {
          label: '接触过中高风险地区人员',
          value: 8
        },
        // {
        //   label: '接触过武汉的客人/亲人',
        //   value: 2
        // },
        {
          label: '接触过有以下症状的客人（发热、咳嗽、乏力、呼吸困难）',
          value: 4
        }, {
          label: '无接触异常人员',
          value: 0
        }],
        handleType:[{
          label: '在院治疗',
          value: 1
        },
        {
          label: '居家观察',
          value: 2
        },
         {
          label: '集中医学观察',
          value: 4
        },
        {
          label: '发热门诊隔离治疗',
          value: 8
        },
        {
          label: '无措施',
          value:0
        }
        ],
        childShequ:[],
        domicileCountry:[{
          label:'国内',
          value:'CHN'
        },{
          label:'国外',
          value:'FOR'
        }],
        validateForm1:[],
        validateForm2:[],
        isLoadZoneList: false,
      };
    },
    //监听属性 类似于data概念
    computed: {},
    //方法集合
    methods: {
      //搜索姓名
      handleSearchPeople(value) {
        console.log(value)
        let url = this.urlobj.residentList();
        this.$post(url, {
          pageNum: 0,
          pageSize: 0,
          residentName: value,
          communityIdList: [this.$store.state.streetorcommunityid]
        })
          .then(res => {
            if (res.isSucceed) {
              /* 如果有数据 */
              if (res.rows.length) {
                /* 初始化数据 */
                this.peopleData = res.rows
                console.log(this.peopleData)
              } else {
                this.peopleData = [];
              }
            }
          })
          .catch(e => {
            console.log(e);
          });
      },
      //选择人员
      handleSelectPeople(value) {
        console.log("=======onselect=============")
        console.log(value)
      },
      saveImg (value) {
        this.imgArr = [value]
        this.people.headPicUrl = this.imgArr[0].path
      },
      delImg () {
        this.people.headPicUrl = ''
        this.imgArr = []
      },

      // 身份证正面
      saveIdCardFImg(value) {
        this.imgIdCardFArr = [value]
        this.people.idCardNOUpPicUrl  = this.imgIdCardFArr[0].path
      },
      delIdCardFImg() {
        this.people.idCardNOUpPicUrl = ''
        this.imgIdCardFArr = []
      },
      // 身份证反面
      saveIdCardBImg(value) {
        this.imgIdCardBArr = [value]
        this.people.idCardNODownPicUrl  = this.imgIdCardBArr[0].path
      },
      delIdCardBImg() {
        this.people.idCardNODownPicUrl = ''
        this.imgIdCardBArr = []
      },
      // 员工健康证明
      saveEHealthImg(value) {
        this.imgEHealthArr = [value]
        this.people.employeeHealthyPicUrl = this.imgEHealthArr[0].path
      },

      delEHealthImg() {
        this.people.employeeHealthyPicUrl = ''
        this.imgEHealthArr =[]
      },

      /**工作凭证 */
      saveImgWork (value) {
        this.imgArrWork = [value]
        this.people.workPromisePicUrl = this.imgArrWork[0].path
      },
      delImgWork () {
        this.people.workPromisePicUrl = ''
        this.imgArrWork = []
      },
      /**承诺书 */
      savePromiseImg (value) {
        this.imgArrPromise = [value]
        this.people.promisePicUrl = this.imgArrPromise[0].path
      },
      delPromiseImg () {
        this.people.promisePicUrl = ''
        this.imgArrPromise = []
      },
      /**健康证明 */
      saveHealthyImg (value) {
        this.imgArrHealthy = [value]
        this.people.healthyPicUrl = this.imgArrHealthy[0].path
      },
      delHealthyImg () {
        this.people.healthyPicUrl = ''
        this.imgArrHealthy = []
      },
        /* 获取年级字典 */
      getGradeList() {
        let url = this.urlobj.dictionaryList("grade");
        return new Promise((resolve, reject) => {
          this.$get(url)
            .then(res => {
              resolve(res);
            })
            .catch(e => console.log(e));
        });
      },
      /* 获取班级字典 */
      getClassList() {
        let url = this.urlobj.dictionaryList("class");
        return new Promise((resolve, reject) => {
          this.$get(url)
            .then(res => {
              resolve(res);
            })
            .catch(e => console.log(e));
        });
      },
      getGradeAndClassList() {
        var getGradeList = this.getGradeList();
        var getClassList = this.getClassList();
          Promise.all([getGradeList, getClassList]).then(res => {
            console.log(res);
              this.gradeList =  res[0].rows.map(item => {
                    return {
                      label: item.dicName,
                      value: item.id
                    };
              })
              this.classList =  res[1].rows.map(item => {
                    return {
                      label: item.dicName,
                      value: item.id
                    };
              })
              
          })
      },
      //获取行政区域
      getArea(item, callback) {
        item.loading = true;
        this.$post(this.urlobj.getArea + 'id=' + item.id).then(res => {
          let data = res.map(_item => {
            let resturn_data = {
              pid: _item.pid,
              id: _item.id,
              //value: _item.pathname,
              value: _item.text,
              label: _item.text,
              level: item.level + 1,
            }
            if (item.level != 2) {
              resturn_data.children = []
              resturn_data.loading = false
            }
            return resturn_data
          })
          if (item.level == 0) {
            this.areadata = data
            // console.log(this.areadata)
          } else {
            item.loading = false;
            item.children = data
            callback()
          }

        }).catch(e => {
          this.$Message.error('获取行政区域失败')
        })
      },
      handleBtn(type) {
        if (type == 'submit') this.submit()
      },
      submit() {
        let data = JSON.parse(JSON.stringify(this.people))
        let setting = this.setting
        console.log(data)
        console.log('class and grade',data.grade,data.class)
        console.log(setting)

        if(setting.headPicUrl && !data.headPicUrl) return this.$Message.error('请上传照片')
        if(setting.idCardNOUpPicUrl && !data.idCardNOUpPicUrl ) return this.$Message.error('请上传身份证正面')
        if(setting.idCardNODownPicUrl && !data.idCardNODownPicUrl ) return this.$Message.error('请上传身份证反面')
        if(setting.employeeHealthyPicUrl && !data.employeeHealthyPicUrl ) return this.$Message.error('请上传健康证明')
        if(setting.returnWorkTime && !data.returnWorkTime ) return this.$Message.error('请选择该员工复工复业时间')
        if(setting.name && !data.name) return this.$Message.error('请填写姓名')
        if(setting.cardno && !data.cardno) return this.$Message.error('请填写身份证号')
        if(setting.nationalId && !data.nationalId) return this.$Message.error('请选择民族')
        if(setting.phone && !data.phone) return this.$Message.error('请填写联系电话')
        if(setting.community_id && !data.communityId) return this.$Message.error('请选择行政区域')

        if(this.$store.state.apptype!='ctt' && !data.zoneId) return this.$Message.error('请选择所属小区')

        if(setting.domicilePalce && !data.domicilePalce.length) return this.$Message.error('请选择户籍地址')
        if(setting.address && !data.address) return this.$Message.error('请填写现居住地址')
        if(setting.liveType && !data.liveType) return this.$Message.error('请选择居住类型')
        if(data.fever == '是'){
          if(setting.handleType && !data.handleType) return this.$Message.error('请选择发热人员处置方式')
        }
        if(setting.contact && !data.contact.length) return this.$Message.error('请选择接触情况')
        if(setting.symptomSelf && !data.symptomSelf.length) return this.$Message.error('请选择自身症状')
        
        if(setting.familyNum && !data.familyNum) return this.$Message.error('请填写家庭成员数量')
        if(setting.familyMember && !data.familyMember) return this.$Message.error('请填写家庭成员姓名,以逗号分隔')
        if(setting.birthday && !data.birthday) return this.$Message.error('请选择出生日期')
        if(setting.symptomFamily && !data.symptomFamily.length) return this.$Message.error('请选择家人症状')
        if(setting.buildingNO && !data.buildingNO) return this.$Message.error('请填写楼栋号')
        if(setting.unitNO && !data.unitNO) return this.$Message.error('请填写单元号')
        if(setting.roomNO && !data.roomNO) return this.$Message.error('请填写房间号')
        if(setting.workPlace && !data.workPlace) return this.$Message.error('请填写工作单位')

        // 离京信息校验（如果有）
        let leaveBj = setting.leaveHere && data.leaveHere == 1
        if(leaveBj && setting.leaveWay && !data.leaveWay) return this.$Message.error('请选择离开方式')
        if(leaveBj && setting.leaveTrips && !data.leaveTrips) return this.$Message.error('请填写离开车次/航班号')
        if(leaveBj && setting.returnWay && !data.returnWay) return this.$Message.error('请选择返回方式')
        if(leaveBj && setting.returnTrips && !data.returnTrips) return this.$Message.error('请填写返回车次/航班号')
        if(leaveBj && setting.returnTime && !data.returnTime) return this.$Message.error('请选择何日离京')
        if(leaveBj && setting.fromWhere && (!data.fromWhere.length)) return this.$Message.error('请选择从何地回京')
        if(leaveBj && setting.backTime && !data.backTime) return this.$Message.error('请选择回京日期')
        if(leaveBj && setting.relation && !data.relation) return this.$Message.error('请填写回京接触人员')
        if(leaveBj && setting.footprint && !data.footprint) return this.$Message.error('请填写所到过的区域')
        if(leaveBj && setting.promisePicUrl && !data.promisePicUrl) return this.$Message.error('请上传承诺书')
        if(leaveBj && setting.healthyPicUrl && !data.healthyPicUrl) return this.$Message.error('请上传健康证明')

        let fromWhere = data.fromCountry == 'CHN'?data.fromWhere.join(','):data.fromWhere
        console.log(fromWhere.indexOf(this.cityremark)>-1)
        if (data.leaveHere == "1" && fromWhere.indexOf(this.cityremark)>-1){
          return this.$Message.error('离'+this.cityremark+'地点不能为本地')
        }

        //是否需要工作校验
        if (
          setting.needGo2Work &&
          data.needGo2Work == 1 &&
          ((setting.workPromisePicUrl && !data.workPromisePicUrl) )
        )
         return this.$Message.error('请上传证明')

        // 如果没有是否需要工作字段，并且有证明字段，则必填
        if (!setting.needGo2Work && setting.workPromisePicUrl && !data.workPromisePicUrl) 
        return this.$Message.error('请上传证明')

        if (data.leaveHere == "2"){
          data.returnTime = ''
          data.fromWhere=''
          data.backTime=''
          data.relation=''
          data.footprint=''
          data.returnWay=''
          data.leaveWay=''
          data.returnTrips=''
          data.leaveTrips=''
        }
        //格式化地址
        if (data.domicileCountry == 'CHN' && typeof(data.domicilePalce) == 'object') data.domicilePalce=data.domicilePalce.join(',')
        console.log(data.fromCountry)
        console.log(data.fromWhere)
        if (data.fromCountry == 'CHN' && typeof(data.fromWhere) == 'object') data.fromWhere=data.fromWhere.join(',')
        //格式化时间
        if (data.returnTime) {
          data.returnTime = this.$util.FormatDate(data.returnTime, "yyyy-MM-dd");
        } else {
          delete data.returnTime
        }

        if (data.returnWorkTime) {
          data.returnWorkTime = this.$util.FormatDate(data.returnWorkTime, "yyyy-MM-dd");
        } else {
          delete data.returnWorkTime
        }

        if (data.backTime) {
          data.backTime = this.$util.FormatDate(data.backTime, "yyyy-MM-dd");
        } else {
          delete data.backTime
        }

        data.birthday = data.birthday?this.$util.FormatDate(data.birthday, "yyyy-MM-dd"):''
        data.contact = this._.sum(data.contact)
        data.symptomSelf = this._.sum(data.symptomSelf)
        data.symptomFamily = this._.sum(data.symptomFamily)
        data.headPicUrl = this.imgArr.length?this.imgArr[0].path:''
        data.idCardNOUpPicUrl  = this.imgIdCardFArr.length?this.imgIdCardFArr[0].path:''
        data.idCardNODownPicUrl = this.imgIdCardBArr.length?this.imgIdCardBArr[0].path:''
        data.employeeHealthyPicUrl = this.imgEHealthArr.length?this.imgEHealthArr[0].path:''
        data.workPromisePicUrl = this.imgArrWork.length?this.imgArrWork[0].path:''
        data.promisePicUrl = this.imgArrPromise.length?this.imgArrPromise[0].path:''
        data.healthyPicUrl = this.imgArrHealthy.length?this.imgArrHealthy[0].path:''
        data.classAndGrade = data.grade + ',' + data.class
        // data.userAttr = 1     // 1 学生 4 家长
        console.log(data)
        this.btnList[0].loading = true
        this.$post(this.urlobj.submitPeople, data).then(res => {
          this.btnList[0].loading = false
          this.$Message.success('提交成功')
          this.$router.go(-1);
        }).catch(e => {
          this.btnList[0].loading = false
          this.$Message.error('提交失败')
        })
      },
      getPeopleDetail() {
        this.$get(this.urlobj.getPeopleFangyiDetail(this.$route.query.id)).then(res => {
          this.spinShow = false
          this.people = res.rows[0]
          // this.people.familyNum = Number(this.people.familyNum)
          //处理radio
          this.people.fever = res.rows[0].fever + ''
          this.people.leaveHere = res.rows[0].leaveHere ? (res.rows[0].leaveHere + '') : '2'
          this.people.isAddToday = res.rows[0].isAddToday ? (res.rows[0].isAddToday + '') : '1'

          this.people.symptomSelf = getIndexAry(res.rows[0].symptomSelf)
          this.people.symptomFamily = getIndexAry(res.rows[0].symptomFamily)
          this.people.contact = getIndexAry(res.rows[0].contact)
          this.imgArr = res.rows[0].headPicUrl?[{path:res.rows[0].headPicUrl}]:[]
          this.imgIdCardFArr = res.rows[0].idCardNOUpPicUrl ?[{path:res.rows[0].idCardNOUpPicUrl}]:[]
          this.imgIdCardBArr = res.rows[0].idCardNODownPicUrl?[{path:res.rows[0].idCardNODownPicUrl}]:[]
          this.imgEHealthArr = res.rows[0].employeeHealthyPicUrl?[{path:res.rows[0].employeeHealthyPicUrl}]:[]
          this.imgArrWork = res.rows[0].workPromisePicUrl?[{path:res.rows[0].workPromisePicUrl}]:[]
          this.imgArrPromise = res.rows[0].promisePicUrl?[{path:res.rows[0].promisePicUrl}]:[]
          this.imgArrHealthy = res.rows[0].healthyPicUrl?[{path:res.rows[0].healthyPicUrl}]:[]
          this.people.domicileCountry = res.rows[0].domicileCountry || 'CHN'
          this.people.fromCountry = res.rows[0].fromCountry || 'CHN'
          this.people.needGo2Work = res.rows[0].needGo2Work?res.rows[0].needGo2Work:0

          this.people.grade =  res.rows[0].classAndGrade?  res.rows[0].classAndGrade.substr(0,res.rows[0].classAndGrade.indexOf(',')) :''  
          this.people.class =  res.rows[0].classAndGrade?  res.rows[0].classAndGrade.substr(res.rows[0].classAndGrade.indexOf(',')+1) :''  
          //处理地址
          // var zhixiashi = ['天津市','北京市','上海市','重庆市']
          // var domicilePalce = res.rows[0].domicilePalce ? res.rows[0].domicilePalce.replace(/\//g,',').split(',') : []
          // var fromWhere = res.rows[0].fromWhere ? res.rows[0].fromWhere.replace(/\//g,',').split(',') : []
          // //国内 && 第一个是直辖市  && 第二个不带直辖市
          // try {
          //   if (res.rows[0].domicileCountry == 'CHN' && zhixiashi.indexOf(domicilePalce[0]) > -1 && domicilePalce[1].indexOf('市辖区') == -1) {
          //     if (domicilePalce[0] == '北京市') domicilePalce[1] ='市辖区'
          //     else domicilePalce[1] +='市辖区'
          //   }
          //   if (res.rows[0].fromCountry == 'CHN' && zhixiashi.indexOf(fromWhere[0]) > -1 && fromWhere[1].indexOf('市辖区') == -1) {
          //     if (fromWhere[0] == '北京市') fromWhere[1] ='市辖区'
          //     else fromWhere[1] +='市辖区'
          //   }
          // }catch (e) {
          //   console.log(e)
          // }
          // console.log(fromWhere)
          this.people.returnWorkTime = res.rows[0].returnWorkTime?this.$util.FormatDate(res.rows[0].returnWorkTime, "yyyy-MM-dd"):'';
          let fromWhere = res.rows[0].fromWhere
          let domicilePalce = res.rows[0].domicilePalce

          this.people.fromWhere = res.rows[0].fromCountry == 'CHN'? (fromWhere?fromWhere.split(','): []):fromWhere
          this.people.domicilePalce = res.rows[0].domicileCountry == 'CHN'?(domicilePalce?domicilePalce.split(','): []):domicilePalce
          //处理直辖市名称问题
          console.log(this.people)
        }).catch(e => {

        })
      },
      getNation() {
        return new Promise((resolve, reject) => {
            this.$get(this.urlobj.dictionaryList('national')).then(res => {
              resolve(res);
            }).catch(e=>{
               reject(e);
            })
          })
      },
      getFangyiSetting() {
        this.$get(this.urlobj.getEpidemicSetting,{
          communityId:this.communityId
        }).then(res => {
          var setting = {}
          res.rows.forEach(item => {
            setting[item.fieldKey] = item.isShow
          })
          this.setting = JSON.parse(JSON.stringify(setting))
          // console.log(setting)
        })
      },
      getChildShequ() {
        var url = this.urlobj.getChildShequ;
        this.$get(url).then(res => {
          var list = res.rows.map(item => {
            return {
              name: item.communityName,
              id: item.communityId
            };
          });
          this.childShequ = list
        });
      },
      //获取微社区列表
      getZoneList(id) {
        this.isLoadZoneList = true
        let url = this.urlobj.zoneList
        return new Promise((resolve, reject) => {
          this.$post(url, {
            communityId: id
          }).then(res => {
            this.isLoadZoneList = false
            resolve(res)
          }).catch(e => {
            this.isLoadZoneList = false
            reject(e)
          })
        })
      },
      changeCommuintyId () {
        this.zoneList = [];
        this.people.zoneId = ''
        if (this.people.communityId != 0) {

          this.getZoneList(this.people.communityId).then(res=>{
            this.zoneList = res.rows
          })
        }
      },
      //点击选择微社区列表时
      selectZone(val) {
        if (val) {
          //下拉框展开，且communityId为空
          if (!this.communityId) {
            this.$Message.info('请先选择社区')
          } else if (this.isLoadZoneList) {
            this.$Message.info('查询中,请稍后')
          }
        }
      },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.getGradeAndClassList()
      //武汉人员单独判断
      if(this.isWuhan){
        
        this.contact[0].label = '接触过确诊或疑似病例'
      }
      if (this.$route.query.id) {
        this.spinShow = true
      }
      this.getChildShequ();

      this.communityId = this.$route.query.communityId || this.$store.state.streetorcommunityid
      // || parseInt(this.$store.state.streetorcommunityid)
      this.getArea({id: '100000000000', level: 0})
      this.getFangyiSetting()
      this.getNation()


      let getNation = this.getNation()
      let getzoneList = this.getZoneList(this.communityId)
      //先获取国籍和微社区列表
      Promise.all([getNation,getzoneList]).then(res=>{
        if (!res[0].isSucceed || !res[1].isSucceed)
            return this.$Message.error(res[0].message || res[1].message);
        this.national = res[0].rows.map(item => {
            return {
              label: item.dicName,
              value: item.id
            }
          })
        this.zoneList = res[1].rows
        if (this.$route.query.id) {
          this.getPeopleDetail()
        }
      })


    },
    beforeCreate() {
    }, //生命周期 - 创建之前
    beforeMount() {
    }, //生命周期 - 挂载之前
    beforeUpdate() {
    }, //生命周期 - 更新之前
    updated() {
    }, //生命周期 - 更新之后
    beforeDestroy() {
    }, //生命周期 - 销毁之前
    destroyed() {
    }, //生命周期 - 销毁完成
    activated() {
    }, //如果页面有keep-alive缓存功能，这个函数会触发
  }

  // 对复选框数值分解
  function getIndexAry(num) {
    let arr = Number(num)
      .toString(2)
      .split("");
    let len = arr.length - 1;

    let res
    if (arr.length == 1 && arr[0] == 0) res=[0]
    else {
      res = arr.map((item, index) => {
        if (+item) return +item * 2 ** (len - index);
      });
    }

    return res;
  }
</script>
<style lang='less' scoped>
  //@import url(); 引入公共css类
  .wrapper {
    height: 100%;
  }

  .card-box {
    margin: 0 20px 20px;
  }

  /deep/ .ivu-card {
    height: 100%;
  }

  /deep/ .ivu-form .ivu-form-item-label {
    font-size: 16px;
  }

  /deep/ .ivu-form-inline .ivu-form-item {
    display: block;
  }

  /deep/ .ivu-date-picker {
    display: block;
  }

  /deep/ .ivu-input-number {
    width: 100% !important;
  }

  /deep/ .ivu-form-item-content {
    line-height: normal;
  }
  .uploadbox {
    width: 100px;
    height: 100px;
    border: 1px dashed #ddd;
    color: #b5b5b5;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    padding: 10px 0;
    font-size: 14px;
    .icon-shangchuan1 {
      display: block;
      font-size: 37px;
    }
  }
  /deep/ .imgbox{
    margin: 0;
  }
</style>
